import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const TOambulatorio = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const condicional = useSelector((state) => state.addForm.modulos)
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if (ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="SETORES DO AMBULATÓRIO" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Número de Setores" nome="toleitos" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        {RenderQtdTO1()}

                    </div>

                    <HeaderVerde texto="TERAPEUTAS QUE TRABALHAM NO SETOR" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Quantos Terapeutas no Setor" nome="tosetorambu" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        {RenderQtdTO2()}
                    </div>

                    <HeaderVerde texto="LEGALIDADE" />
                    <div style={{ textAlign: "left" }}>
                        <Select label="CONFORMIDADE COM A RESOLUÇÃO COFFITO Nº 445/2014" nome="resolucao445" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="15vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        {RenderCondicional3()}
                        <Observacoes widthWeb="83vw" widthMobile="80vw" modulo={modulo} index={n} nome="observacoes" />
                    </div>
                </Caixa >
            )

            function RenderQtdTO2() {
                let campos = []
                if (condicional[modulo].length > 0) var array = condicional
                else var array = ficha
                var quantidade = array[modulo][n]["tosetorambu"]
                if (array[modulo][n]["tosetorambu"]) {
                    for (let i = 0; i < quantidade; i++) {
                        campos.push(
                            <div>

                                <Input label="Profissional" nome="toprofissionalambu" modulo={modulo} index={n}
                                    subModulo="toprofissionalnalambu" indexSub={i} componentDisplay="inline-grid" widthWeb="20vw"
                                    widthMobile="80vw" marginR="3vw" />
                                <Input label="Número do Crefito" nome="toinscricaoambu" modulo={modulo} index={n} subModulo="toinscricaoambu"
                                    indexSub={i} componentDisplay="inline-grid" widthWeb="10vw" widthMobile="80vw" marginR="3vw" />
                                <Input label="Dia/Horário" nome="toinscricaoambu" modulo={modulo} index={n} subModulo="toinscricaoambu"
                                    indexSub={i} componentDisplay="inline-grid" widthWeb="10vw" widthMobile="80vw" marginR="3vw" />
                                <Input label="Setor de Atuação" nome="toinscricaoambu" modulo={modulo} index={n} subModulo="toinscricaoambu"
                                    indexSub={i} componentDisplay="inline-grid" widthWeb="12vw" widthMobile="80vw" marginR="3vw" />
                                <Input label="Nº de Pacientes Atendidos" nome="toleitosSub" modulo={modulo} index={n}
                                    subModulo="toleitosSub" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />

                            </div>
                        )
                    }
                    return campos
                }
            }
            function RenderQtdTO1() {
                let campos = []
                if (condicional[modulo].length > 0) var array = condicional
                else var array = ficha
                var quantidade = array[modulo][n]["toleitos"]
                if (array[modulo][n]["toleitos"]) {
                    for (let i = 0; i < quantidade; i++) {
                        campos.push(
                            <div>
                                <Input label="Nome do Setor" nome="tonomeambu" modulo={modulo} index={n}
                                    subModulo="tonomeambu" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="30vw" widthMobile="80vw" marginR="3vw" />
                                <Select label="Há lista de espera?" nome="listaEspera"
                                    modulo={modulo} index={n} subModulo="listaEspera" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="15vw" widthMobile="80vw" marginR="3vw"
                                    array={["Sim", "Não"]} />
                            </div>
                        )
                    }
                    return campos
                }
            }
            function RenderCondicional3() {
                let campos = []
                if (condicional[modulo].length > 0) var array = condicional
                else var array = ficha
                var quantidade = array[modulo][n]["residenciaprograma"]
                if (array[modulo][n]["residenciaprograma"]) {
                    campos.push(
                        <>
                            <Input label="Profissional(s) em desconformidade" nome="toconformidade" modulo={modulo} index={n} subModulo="toconformidade"
                                componentDisplay="block" widthWeb="60vw" widthMobile="80vw" marginR="3vw" />
                        </>
                    )
                }
                return campos
            }
        }
        return partes

    }
}
export default TOambulatorio